import React, { Component } from 'react';
import { Footer } from '../Components/Footer.js';
import TitleCard from '../Components/TitleCard.js';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../Components/Button.js';
import CurrencyInput from '../Components/CurrencyInput';
import styles from './Simulator.module.css';
// import SocialPyramid from '../Components/SocialPyramid.js';

class Simulator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 'aproximada',
            rendaAproximada: '',
            ufSelecionado: '',
            ufs: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA', 'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'],
            detalhada: {
                tributaveis: '',
                isentos: '',
                exclusivos: '',
                uf: '',
            },
            modo: 'aproximada',
            rankingBrasil: '-',
            rankingEstado: '-',
            centil: '-',
            centilEstado: '-',
            loading: false,
            ultimaAtualizacaoDados: '04/2025',
            resultado: null,
            // resultado: [
            //     {
            //         "id": 30318073,
            //         "id_pessoa": "15027876_BR",
            //         "uf": "BR",
            //         "distancia_01": 37,
            //         "renda_bruta_anual": "48000.00",
            //         "ranking_uf_renda_bruta": 25642721,
            //         "percentual_centil": "45"
            //     },
            //     {
            //         "id": 26947915,
            //         "id_pessoa": "138058_PI",
            //         "uf": "PI",
            //         "distancia_01": 41,
            //         "renda_bruta_anual": "47999.91",
            //         "ranking_uf_renda_bruta": 200175,
            //         "percentual_centil": "69"
            //     }
            // ],
            rendaNumerica: 0,
            // rendaNumerica: 7000,
            outrasRendas: '',
            recebeDecimoTerceiro: false,
            rendaMensal: 0,
            rendaAnual: 0,
        };
    }

    handleUfChange = (e) => {
        this.setState({ ufSelecionado: e.target.value });
    };

    handleUfChangeDetalhada = (e) => {
        this.setState(prevState => ({
            detalhada: {
                ...prevState.detalhada,
                uf: e.target.value,
            }
        }));
    };

    handleBuscarPosicao = () => {
        const { rendaAproximada, ufSelecionado } = this.state;
        if (!rendaAproximada || rendaAproximada.trim() === '' || rendaAproximada === 'R$ 0,00') {
            alert('Informe sua renda mensal.');
            return;
        }
        if (!ufSelecionado) {
            alert('Informe o UF.');
            return;
        }
        const rendaNumerica = parseFloat(
            rendaAproximada
                .replace(/[^\d,]/g, '') // remove R$, pontos etc
                .replace(/\./g, '')     // remove separador de milhar
                .replace(',', '.')      // troca vírgula decimal por ponto
        );

        let rendaMensal = rendaNumerica;

        let rendaAnual = parseFloat((rendaNumerica * 12).toFixed(2));

        if (this.state.recebeDecimoTerceiro) {
            rendaAnual += parseFloat((rendaNumerica).toFixed(2));
            rendaMensal += parseFloat((rendaNumerica / 12).toFixed(2));
        }

        const outrasRendasNumerica = this.state.outrasRendas ? parseFloat(
            this.state.outrasRendas
                .replace(/[^\d,]/g, '') // remove R$, pontos etc
                .replace(/\./g, '')     // remove separador de milhar
                .replace(',', '.')      // troca vírgula decimal por ponto
        ) : 0;

        if (outrasRendasNumerica && outrasRendasNumerica > 0) {
            rendaAnual += parseFloat((outrasRendasNumerica * 12).toFixed(2));
            rendaMensal += parseFloat((outrasRendasNumerica).toFixed(2));
        }

        rendaMensal = parseFloat((rendaMensal).toFixed(2));
        rendaAnual = parseFloat((rendaAnual).toFixed(2));

        if (rendaAnual === 0) {
            alert('Informe sua renda mensal.');
            return;
        }

        this.setState({ rendaAnual, rendaMensal });

        this.setState({ loading: true, rendaNumerica });
        fetch(`${process.env.REACT_APP_API_URL}/dados-irpf/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                // renda_bruta_anual: rendaAnual,
                renda_bruta_mensal: rendaMensal,
                uf: ufSelecionado || null,
                // outras_rendas: outrasRendasNumerica
            })
        })
            .then(res => res.json())
            .then(data => {
                this.setState({
                    resultado: data,
                    loading: false
                });
            })
            .catch((error) => {
                // let msg = "Erro ao buscar posição:\n";
                // if (error instanceof Error) {
                //     msg += `${error.name}: ${error.message}\n${error.stack || ''}`;
                // } else {
                //     msg += JSON.stringify(error);
                // }
                // alert(msg);
                this.setState({ loading: false });
            });
    };

    handleBuscarPosicaoDetalhada = () => {
        const { detalhada } = this.state;
        const { tributaveis, isentos, exclusivos, uf } = detalhada;

        // Validação dos campos
        if (!tributaveis && !isentos && !exclusivos) {
            alert('Informe pelo menos um valor de rendimento.');
            return;
        }
        if (!uf) {
            alert('Informe o UF.');
            return;
        }

        // Função para converter string moeda para número
        const parseCurrency = (str) => {
            if (!str) return 0;
            return parseFloat(
                str
                    .replace(/[^\d,]/g, '') // remove R$, pontos etc
                    .replace(/\./g, '')     // remove separador de milhar
                    .replace(',', '.')      // troca vírgula decimal por ponto
            ) || 0;
        };

        let rendaNumerica =
            parseCurrency(tributaveis) +
            parseCurrency(isentos) +
            parseCurrency(exclusivos);

        rendaNumerica = parseFloat((rendaNumerica).toFixed(2))

        this.setState({ rendaNumerica, rendaAnual: rendaNumerica });

        this.setState({ loading: true });
        fetch(`${process.env.REACT_APP_API_URL}/dados-irpf/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                renda_bruta_anual: rendaNumerica,
                uf: uf || null
            })
        })
            .then(res => res.json())
            .then(data => {
                this.setState({
                    resultado: data,
                    loading: false
                });
            })
            .catch(() => this.setState({ loading: false }));
    }

    handleSelect = (tipo) => {
        this.setState({
            selected: tipo,
            resultado: null,
            rendaAproximada: '',
            ufSelecionado: '',
            detalhada: {
                tributaveis: '',
                isentos: '',
                exclusivos: '',
                uf: '',
            }
        });
    };

    handleInputChange = (field, value, detalhada = false) => {
        const onlyDigits = value.replace(/\D/g, '');
        const numericValue = parseFloat(onlyDigits) / 100;

        const formatted = isNaN(numericValue)
            ? ''
            : numericValue.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            });

        if (detalhada) {
            this.setState((prevState) => ({
                detalhada: {
                    ...prevState.detalhada,
                    [field]: formatted,
                },
            }));
        } else {
            this.setState({ [field]: formatted });
        }
    };

    handleEstadoChange = (e) => {
        this.setState((prevState) => ({
            detalhada: {
                ...prevState.detalhada,
                estado: e.target.value,
            },
        }));
    };

    buscarRanking = () => {
        this.setState({ loading: true });
        setTimeout(() => {
            this.setState({
                rankingBrasil: '1.254',
                rankingEstado: '324',
                centil: '95',
                centilEstado: '92',
                loading: false,
            });
        }, 1000);
    };

    formatCurrency = (value) => {
        return value.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
    };


    render() {
        const { selected } = this.state;

        let resposta0 = this.state.rendaAnual <= 300;
        let resposta1 = this.state.rendaAnual > 300 && this.state.rendaAnual < 40345;
        let resposta2 = this.state.rendaAnual >= 40345 && this.state.rendaAnual <= 50000;
        let resposta3 = this.state.rendaAnual > 50000 && this.state.rendaAnual < 600000;
        let resposta4 = this.state.rendaAnual >= 600000 && this.state.rendaAnual < 1937967;
        let resposta5 = this.state.rendaAnual >= 1937967;

        return (
            <div className={styles.container}>
                <div
                    className={styles.homeFirstBlock}
                    style={{
                        backgroundImage: `
                            linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0) 15%),
                            linear-gradient(to bottom, rgba(255,255,255,0) 80%, #fff 100%),
                            url('/images/home/background.svg')
                        `,
                    }}
                >
                    <div className={`${styles.homeFirstBlockLeft} ${styles.homeFirstBlockLarge}`}>
                        <div className={styles.breadcrumb}>
                            <img
                                src="/images/icons/home.svg"
                                width="18"
                                alt="Home"
                            />
                            <Link to="/" className={styles.breadcrumbLink}>
                                Início
                            </Link>
                            <ChevronRight className={styles.breadcrumbIcon} />
                            <span className={styles.breadcrumbCurrent}>Simulador da Renda</span>
                        </div>
                        <TitleCard
                            iconLeft={<img
                                src="/images/icons/simulador.svg"
                                width="18"
                                alt="Simulador da Renda"
                            />}
                            label='SIMULADOR DE RENDA'
                        />
                        <span className={styles.titleText}>
                            Descubra sua posição no ranking da pirâmide de renda do Brasil
                        </span>
                        <div className={styles.textVideoBlock}>
                            <span className={styles.subtitleText}>
                                Já se perguntou em que ponto você está na pirâmide da distribuição de renda do país?
                                <br />
                                <br />
                                A plataforma desenvolvida pela equipe da <b>FiscalData</b> permite que você descubra <b>sua posição exata no ranking de renda do Brasil</b>, com base em um <b>simulador estatístico</b> alimentado por dados reais extraídos das declarações do Imposto de Renda das Pessoas Físicas (IRPF).
                                <br />
                                <br />
                                Mais do que saber se você está entre os <b>10%</b> ou <b>1%</b> mais ricos, aqui você saberá precisamente quantas pessoas estão acima e abaixo de você na pirâmide.
                            </span>
                            <div className={styles.videoBlock}>
                                <video
                                    width="100%"
                                    height="400"
                                    autoPlay
                                    loop
                                    muted
                                    controls
                                    playsInline
                                    // poster="/images/thumb-video.png" // thumbnail do vídeo
                                    className={styles.iframe}
                                >
                                    <source src="/videos/simulator.mp4" type="video/mp4" />
                                    Seu navegador não suporta o vídeo.
                                </video>
                            </div>
                        </div>

                    </div>

                </div>
                <div className={styles.homeFirstBlock2}>
                    <div className={styles.homeFirstBlockCenter}>
                        <TitleCard
                            iconLeft={<img
                                src="/images/icons/escolha_certa.svg"
                                width="18"
                                alt="A FiscalData"
                            />}
                            label='RENDA'
                        />
                        <span className={styles.titleText} style={{ fontSize: '40px', textAlign: 'center' }}>
                            Você pode optar por fazer a simulação informando apenas um valor aproximado da sua renda mensal.
                        </span>
                        <span style={{ fontSize: '18px', color: '#606060', marginTop: '10px', maxWidth: '90%', marginBottom: '10px' }}>
                            No entanto, para obter um resultado mais preciso, recomendamos utilizar a consulta detalhada, preenchendo os dados da sua declaração de Imposto de Renda de 2025 (ano-base 2024).
                        </span>
                        <div className={styles.selectImages}>
                            <img
                                src={selected === 'aproximada' ? "/images/simulator/big_aprox.svg" : "/images/simulator/low_aprox.svg"}
                                width={selected === 'aproximada' ? "180" : "150"}
                                alt="Renda Aproximada"
                                style={{ cursor: 'pointer', transition: 'width 0.2s' }}
                                onClick={() => this.handleSelect('aproximada')}
                            />
                            <img
                                src={selected === 'detalhada' ? "/images/simulator/big_det.svg" : "/images/simulator/low_det.svg"}
                                width={selected === 'detalhada' ? "180" : "150"}
                                alt="Renda Detalhada"
                                style={{ cursor: 'pointer', transition: 'width 0.2s', marginLeft: '10px' }}
                                onClick={() => this.handleSelect('detalhada')}
                            />
                        </div>
                        {selected === 'aproximada' && (
                            <div className={styles.simulatorInputsBlock}>
                                <span style={{ fontSize: '32px', fontWeight: 'bold', color: '#3C3C3C' }}>Informações sobre a sua renda</span>
                                <span style={{ fontSize: '18px', color: '#606060', marginTop: '10px', maxWidth: '90%' }}>
                                    Qual é a sua renda mensal habitual proveniente de salários?
                                </span>
                                <span style={{ fontSize: '16px', color: '#606060', marginTop: '2px', maxWidth: '90%', marginBottom: '10px' }}>
                                    Valor referente a sua renda individual bruta
                                </span>
                                <CurrencyInput
                                    placeholder='Renda mensal habitual'
                                    value={this.state.rendaAproximada}
                                    onChange={e => this.handleInputChange('rendaAproximada', e.target.value)}
                                />
                                <div style={{ margin: '10px 0', display: 'flex', width: '90%' }}>
                                    <input
                                        type="checkbox"
                                        id="decimo-terceiro"
                                        checked={this.state.recebeDecimoTerceiro || false}
                                        onChange={e => this.setState({ recebeDecimoTerceiro: e.target.checked })}
                                        style={{ marginRight: '8px' }}
                                    />
                                    <span htmlFor="decimo-terceiro" style={{ fontSize: '16px', color: '#606060' }}>
                                        Recebe décimo terceiro salário?
                                    </span>
                                </div>
                                <span style={{ fontSize: '18px', color: '#606060', marginTop: '10px', maxWidth: '90%', marginBottom: '10px' }}>
                                    Recebe outras fontes de renda, como <b>aluguéis, aplicações financeiras, dividendos ou ganhos de capital</b>?
                                    Informe a <b>média mensal</b> desses rendimentos para que a simulação reflita melhor sua renda total.
                                </span>
                                <CurrencyInput
                                    placeholder='Outras rendas mensais'
                                    value={this.state.outrasRendas}
                                    onChange={e => this.handleInputChange('outrasRendas', e.target.value)}
                                />
                                <div style={{ margin: '16px 0', width: '90%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                    <span className={styles.inputLabel}>Estado (UF) de residência:</span>
                                    <select
                                        id="uf-select"
                                        value={this.state.ufSelecionado}
                                        onChange={this.handleUfChange}
                                        className={styles.select}
                                    >
                                        <option value="">Selecione o UF</option>
                                        {this.state.ufs.map(uf =>
                                            <option key={uf.value || uf} value={uf.value || uf}>
                                                {uf.label || uf}
                                            </option>
                                        )}
                                    </select>
                                </div>
                                <Button
                                    label={this.state.loading ? "Buscando..." : "Descobrir minha posição"}
                                    variant="primary"
                                    iconRight={<ChevronRight />}
                                    onClick={this.handleBuscarPosicao}
                                    disabled={this.state.loading}
                                />
                                {/* <span style={{ fontSize: '14px', color: '#606060', marginTop: '10px', maxWidth: '90%', marginBottom: '10px', fontWeight: 'bold' }}>
                                    <sup>*</sup> Esses valores serão corrigidos pela taxa de inflação de 1,0981, correspondente à taxa de inflação entre 01/07/2023 e 30/06/2025.
                                </span> */}
                            </div>
                        )}
                        {selected === 'detalhada' && (
                            <div className={styles.simulatorInputsBlock}>
                                <span style={{ fontSize: '32px', fontWeight: 'bold', color: '#3C3C3C' }}>Preencha conforme sua declaração anual do Imposto de Renda</span>
                                <span style={{ fontSize: '18px', color: '#606060', marginTop: '10px', maxWidth: '90%' }}>
                                    Acesse o arquivo de sua declaração de IRPF de 2025 (ano base 2024) e consulte os valores de renda informados nas duas últimas páginas de resumo da declaração:
                                </span>
                                <span style={{ fontSize: '16px', alignSelf: 'flex-start', marginLeft: '5%', marginTop: '20px' }}>Rendimentos Tributáveis (TOTAL) da penúltima página:</span>
                                <CurrencyInput
                                    placeholder='Rendimentos Tributáveis (TOTAL) - penúltima página'
                                    value={this.state.detalhada.tributaveis}
                                    onChange={e => this.handleInputChange('tributaveis', e.target.value, true)}
                                />
                                <span style={{ fontSize: '16px', alignSelf: 'flex-start', marginLeft: '5%', marginTop: '20px' }}>Rendimentos Isentos e Não Tributáveis:</span>
                                <CurrencyInput
                                    placeholder='Outras Informações/Rendimentos Isentos e Não Tributáveis – última página'
                                    value={this.state.detalhada.isentos}
                                    onChange={e => this.handleInputChange('isentos', e.target.value, true)}
                                />
                                <span style={{ fontSize: '16px', alignSelf: 'flex-start', marginLeft: '5%', marginTop: '20px' }}>Rendimentos Sujeitos à Tributação Exclusiva/Definitiva (no bloco Outras Informações):</span>
                                <CurrencyInput
                                    placeholder='Outras Informações/Rendimentos Sujeitos à Tributação Exclusiva/Definitiva – última página'
                                    value={this.state.detalhada.exclusivos}
                                    onChange={e => this.handleInputChange('exclusivos', e.target.value, true)}
                                />
                                <div style={{ margin: '16px 0', width: '90%', display: 'flex', alignItems: 'center', flexDirection: 'column', marginTop: '20px', marginBottom: '30px' }}>
                                    <span className={styles.inputLabel}>Estado (UF) de residência:</span>
                                    <select
                                        id="uf-select"
                                        value={this.state.detalhada.uf}
                                        onChange={this.handleUfChangeDetalhada}
                                        className={styles.select}
                                    >
                                        <option value="">Selecione o UF</option>
                                        {this.state.ufs.map(uf =>
                                            <option key={uf.value || uf} value={uf.value || uf}>
                                                {uf.label || uf}
                                            </option>
                                        )}
                                    </select>
                                </div>
                                <Button
                                    label={this.state.loading ? "Buscando..." : "Descobrir minha posição"}
                                    variant="primary"
                                    iconRight={<ChevronRight />}
                                    onClick={this.handleBuscarPosicaoDetalhada}
                                    disabled={this.state.loading}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {this.state.resultado && Array.isArray(this.state.resultado) && (
                    <div className={styles.resultadosWrapper}>
                        <div className={`${styles.blockWidth} ${styles.simulatorResultBlock}`}>
                            <div className={styles.resultDetails}>
                                {resposta0 && (
                                    <>
                                        Você está entre os <b>{Number(this.state.resultado[0].percentual_centil).toFixed(2)}%</b> mais pobres do Brasil.
                                        <br />
                                    </>
                                )}
                                {resposta1 && (
                                    <>
                                        Você está entre os <b>{Number(this.state.resultado[0].percentual_centil).toFixed(0)}%</b> mais pobres do Brasil.
                                        <br />
                                        <br />
                                        Sua renda é menor que a média nacional (<b>R$ 3.991</b> mensais, em <b>2024</b>). Isso acontece porque a renda é tão concentrada no topo da pirâmide, que a grande maioria da população fica abaixo da média.
                                        <br />
                                        <br />
                                        A distância entre você e o topo da pirâmide é gigantesca. Os super-ricos (<b>0,1%</b> da população) ganham <b>R$ 577 mil</b> por mês em média, ou seja <b>{Number(this.state.resultado[0].distancia_01)}</b> vezes mais que você.
                                        <br />
                                        <br />
                                        Considerando um ranking da renda nacional, há <b>{Number(this.state.resultado[0].p_mais_pobres).toLocaleString('pt-BR')}</b> pessoas mais pobres que você e <b>{Number(this.state.resultado[0].p_mais_ricas).toLocaleString('pt-BR')}</b> mais ricas.
                                        <br />
                                        <br />
                                    </>
                                )}
                                {resposta2 && (
                                    <>
                                        Você está entre os <b>{Number(this.state.resultado[0].percentual_centil).toFixed(2)}%</b> mais ricos do Brasil{this.state.resultado[1] && (
                                            this.state.resultado[1].percentual_centil > 20 ?
                                                <> e não está entre os <b>20%</b> mais ricos do seu estado</>
                                                :
                                                <> e entre os <b>{Number(this.state.resultado[1].percentual_centil).toFixed(2)}%</b> mais ricos do seu estado</>
                                        )}.
                                        <br />
                                        <br />
                                        Mas sua renda está próxima à média nacional (<b>R$ 3.991</b> mensais, em <b>2024</b>). Isso acontece porque a renda é tão concentrada no topo da pirâmide, que a grande maioria da população fica abaixo da média.
                                        <br />
                                        <br />
                                        Já a distância entre você e o topo da pirâmide é enorme. Os super-ricos (<b>0,1%</b> da população) ganham <b>R$ 577 mil</b> por mês em média, ou seja, cerca de <b>{Number(this.state.resultado[0].distancia_01)}</b> vezes a mais que você.
                                        <br />
                                        <br />
                                        Considerando um ranking da renda nacional, há <b>{Number(this.state.resultado[0].p_mais_pobres).toLocaleString('pt-BR')}</b> pessoas mais pobres que você e <b>{Number(this.state.resultado[0].p_mais_ricas).toLocaleString('pt-BR')}</b> mais ricas.
                                    </>
                                )}
                                {resposta3 && (
                                    <>
                                        Você está entre os <b>{Number(this.state.resultado[0].percentual_centil).toFixed(2)}%</b> mais ricos do Brasil{this.state.resultado[1] && (
                                            this.state.resultado[1].percentual_centil > 20 ?
                                                <> e não está entre os <b>20%</b> mais ricos do seu estado</>
                                                :
                                                <> e entre os <b>{Number(this.state.resultado[1].percentual_centil).toFixed(2)}%</b> mais ricos do seu estado</>
                                        )}.
                                        <br />
                                        <br />
                                        Sua renda é mais de <b>{Number(this.state.resultado[0].distancia_media)}</b> vezes superior à média nacional (<b>R$ 3.991</b> mensais, em <b>2024</b>).
                                        <br />
                                        <br />
                                        Mas você ainda está longe do topo da pirâmide. Os super-ricos (<b>0,1%</b> da população) ganham <b>R$ 577 mil</b> por mês em média, ou seja, cerca de <b>{Number(this.state.resultado[0].distancia_01)}</b> vezes a mais que você.
                                        <br />
                                        <br />
                                        Considerando um ranking da renda nacional, há <b>{Number(this.state.resultado[0].p_mais_pobres).toLocaleString('pt-BR')}</b> pessoas mais pobres que você e <b>{Number(this.state.resultado[0].p_mais_ricas).toLocaleString('pt-BR')}</b> mais ricas.
                                    </>
                                )}
                                {resposta4 && (
                                    <>
                                        Você está entre os  <b>{Number(this.state.resultado[0].percentual_centil).toFixed(2)}%</b>  mais ricos do Brasil{this.state.resultado[1] && (
                                            <> e entre os <b>{Number(this.state.resultado[1].percentual_centil).toFixed(2)}%</b> mais ricos do seu estado</>
                                        )}.
                                        <br />
                                        <br />
                                        Sua renda é mais de <b>{Number(this.state.resultado[0].distancia_media)}</b> vezes superior à média nacional (<b>R$ 3.991</b> mensais, em <b>2024</b>).
                                        <br />
                                        <br />
                                        Você está perto do topo da pirâmide. Os super-ricos (<b>0,1%</b> da população) ganham <b>R$ 577 mil</b> por mês em média, ou seja, cerca de <b>{Number(this.state.resultado[0].distancia_01)}</b> vezes a mais que você.
                                        <br />
                                        <br />
                                        Considerando um ranking da renda nacional, há <b>{Number(this.state.resultado[0].p_mais_pobres).toLocaleString('pt-BR')}</b> pessoas mais pobres que você e <b>{Number(this.state.resultado[0].p_mais_ricas).toLocaleString('pt-BR')}</b> mais ricas.
                                    </>
                                )}
                                {resposta5 && (
                                    <>
                                        Você está no topo da pirâmide nacional, entre os <b>{Number(this.state.resultado[0].percentual_centil).toFixed(6)}%</b> mais ricos do Brasil{this.state.resultado[1] && (
                                            <> e entre os <b>{Number(this.state.resultado[1].percentual_centil).toFixed(6)}%</b> mais ricos do seu estado</>
                                        )}.
                                        <br />
                                        <br />
                                        Sua renda é cerca de <b>{Number(this.state.resultado[0].distancia_media)}</b> vezes maior que a média do país (<b>R$ 3.991</b> mensais, em <b>2024</b>).
                                        <br />
                                        <br />
                                        Considerando um ranking da renda nacional, há <b>{Number(this.state.resultado[0].p_mais_pobres).toLocaleString('pt-BR')}</b> pessoas mais pobres que você e apenas <b>{Number(this.state.resultado[0].p_mais_ricas).toLocaleString('pt-BR')}</b> mais ricas.
                                    </>
                                )}

                                {/* <b>Percentil:</b> {this.state.resultado[0]?.percentual_centil}% */}
                                {/* <b>Renda bruta anual:</b> R$ {parseFloat(this.state.resultado[0]?.renda_bruta_anual).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                <br />
                                <span className={styles.resultText}>
                                    {this.state.resultado && Array.isArray(this.state.resultado) && this.state.resultado[0] && (

                                        <>
                                            Você está entre os {this.state.resultado[0]?.percentual_centil}% com {this.state.rendaAnual > 36036 ? 'maior' : 'menor'} renda no Brasil
                                        </>
                                    )}
                                </span>
                                <br />
                                <div className={styles.resultText}>

                                    <div className={styles.resultText}>
                                        Sua renda é cerca de <b>{Number(this.state.resultado[0].distancia_media)}</b> vezes <b>{maiorOuMenorMedia}</b> que a média nacional (R$ 3.003,00 por mês).
                                        <br />
                                        {parseFloat(this.state.resultado[0]?.percentual_centil) <= 0.1 ? (
                                            <>Você está no topo da pirâmide de renda (acima de 99,9% da população).</>
                                        ) : parseFloat(this.state.resultado[0]?.percentual_centil) <= 1 ? (
                                            <>Você está muito próximo do topo da pirâmide de renda (acima de 99% da população).</>
                                        ) : (
                                            <>Há uma grande distância entre você e o topo da pirâmide (1% da população).</>
                                        )}                                    <br />
                                        Sua renda é <b><b>{vezesMediaSuperRicos}</</b>b> vezes <b>{maiorOuMenorSuperRicos}</b> que a média declarada pelos super-ricos (R$ 103.600,00 por mês).
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {/* {this.state.resultado && Array.isArray(this.state.resultado) && this.state.resultado[1] && (
                            <div className={`${styles.blockWidth} ${styles.simulatorResultBlock}`}>
                                <span className={styles.resultTitle}>Sua posição no estado ({selected == 'detalhada' ? this.state.detalhada.uf : this.state.ufSelecionado})</span>
                                {/* <span className={styles.resultText}>
                                    <>
                                        No seu estado ({this.state.resultado[1].uf}), você está entre os <b>{this.state.resultado[1].percentual_centil}%</b> mais ricos,
                                        ocupando a posição número <b>{this.state.resultado[1].ranking_uf_renda_bruta.toLocaleString('pt-BR')}</b> no ranking estadual de renda declarada.
                                    </>
                                </span> */}
                        {/* <div className={styles.resultDetails}>
                            <br />
                            <b>Ranking estadual:</b> {this.state.resultado[1]?.ranking_uf_renda_bruta?.toLocaleString('pt-BR')}
                            <br />
                            <b>Renda bruta anual:</b> R$ {parseFloat(this.state.resultado[1]?.renda_bruta_anual).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                            <br />
                            <span className={styles.resultText}>
                                {this.state.resultado && Array.isArray(this.state.resultado) && this.state.resultado[0] && (

                                    <>
                                        Você está entre os {this.state.resultado[1]?.percentual_centil}% com {this.state.rendaAnual > 36036 ? 'maior' : 'menor'} renda no seu estado
                                    </>
                                )}
                            </span>
                        </div> */}
                    </div>
                )}
                <div className={styles.metodologiaBlock}>
                    <div className={styles.metodologiaInner}>
                        <TitleCard
                            iconLeft={<img
                                src="/images/icons/conheca_fiscaldata.svg"
                                width="18"
                                alt="A FiscalData"
                            />}
                            label='METODOLOGIA'
                        />
                        <span className={styles.metodologiaTitle}>
                            Metodologia e fonte de dados
                        </span>
                        <span className={styles.metodologiaText}>
                            A estimativa da sua posição na pirâmide foi feita com base nos dados das declarações do IRPF 2025 (ano-base 2024) fornecidos pela Receita Federal. Os dados foram estratificados por centil de renda declarada, para cada unidade federada, com uso de limites mínimo e máximo, além da renda média por centil. Aplicamos procedimentos estatísticos para estimar com precisão sua posição individual no ranking nacional e estadual.
                        </span>
                        <span className={styles.metodologiaFonte}>
                            Fontes: Receita Federal – Estatísticas do IRPF 2024 | Metodologia FiscalData <br />
                            Nota de privacidade: os dados inseridos não são armazenados.<br />
                            {/* Última atualização dos dados: 04/2025 */}
                        </span>
                    </div>
                </div>
                <div className='home-first-block home-blocks' style={{ backgroundColor: '#fff', width: '100%', justifyContent: 'center' }}>
                    <div className='home-first-block-center'  style={{ width: '100%' }}>
                        <TitleCard
                            iconLeft={<img
                                src="/images/icons/institucional.svg"
                                width="18"
                                alt="Institucional"
                            />}
                            label='INSTITUCIONAL'
                        />
                        <span className={styles.titleText}>
                            Parceiros FiscalData
                        </span>
                        <div className='partners-block'>

                            <div className='support-img-block'>
                                <img
                                    src="/images/ccif.png"
                                    // width="90"
                                    height="60"
                                    className="d-inline-block align-top"
                                    alt="img"
                                    onClick={() => window.open("https://ccif.com.br/", "_blank")}
                                />
                            </div>

                            <div className='support-img-block'>
                                <img
                                    src="/images/febrafite.svg"
                                    // width="90"
                                    height="90"
                                    className="d-inline-block align-top"
                                    alt="img"
                                    onClick={() => window.open("https://www.febrafite.org.br/", "_blank")}
                                />
                            </div>

                            <div className='support-img-block'>
                                <img
                                    src="/images/fenafim.jpeg"
                                    // width="90"
                                    height="60"
                                    className="d-inline-block align-top"
                                    alt="img"
                                    onClick={() => window.open("https://www.fenafim.org.br/site/", "_blank")}
                                />
                            </div>




                            <div className='support-img-block'>
                                <img
                                    src="/images/sindifisco.png"
                                    // width="90"
                                    height="60"
                                    className="d-inline-block align-top"
                                    alt="img"
                                    onClick={() => window.open("https://www.sindifisconacional.org.br/", "_blank")}
                                />
                            </div>



                            <div className='support-img-block'>
                                <img
                                    src="/images/mais_progresso.jpeg"
                                    // width="90"
                                    height="170"
                                    className="d-inline-block align-top"
                                    alt="img"
                                    onClick={() => window.open("https://maisprogresso.org/", "_blank")}
                                />
                            </div>

                            <div className='support-img-block'>
                                <img
                                    src="/images/oxfam.jpeg"
                                    // width="90"
                                    height="70"
                                    className="d-inline-block align-top"
                                    alt="img"
                                    onClick={() => window.open("https://www.oxfam.org.br/", "_blank")}
                                />
                            </div>

                        </div>


                    </div>
                </div>
                <Footer />
            </div >
        );
    }
}

export default Simulator;